import { SearchRoomChildParams } from './../../types/paramModels';
import { SearchAirport, SearchPerson, SearchRoom, SearchTravelRequest } from '@/types/models';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true, })
class TravelSearchModule extends VuexModule {
    public searchTravelRequest?: SearchTravelRequest;

    @Mutation
    public setSearchTravelRequest(searchTravelRequest: SearchTravelRequest): void {
        this.searchTravelRequest = searchTravelRequest;
    }

    @Action
    public updateSearchTravelRequest(searchTravelRequest: SearchTravelRequest): void {
        this.context.commit('setSearchTravelRequest', searchTravelRequest);
    }

    get getSearchTravelRequest(): SearchTravelRequest {
        return this.searchTravelRequest as SearchTravelRequest;
    }

    @Mutation
    public setSearchTravelRequestDateFrom(dateFrom: string): void {
        if (this.searchTravelRequest)
            this.searchTravelRequest.dateFrom = dateFrom;
    }

    @Action
    public updateSearchTravelRequestDateFrom(dateFrom: string): void {
        this.context.commit('setSearchTravelRequestDateFrom', dateFrom);
    }

    @Mutation
    public setSearchTravelRequestDateTo(dateTo: string): void {
        if (this.searchTravelRequest)
            this.searchTravelRequest.dateTo = dateTo;
    }

    @Action
    public updateSearchTravelRequestDateTo(dateTo: string): void {
        this.context.commit('setSearchTravelRequestDateTo', dateTo);
    }

    @Mutation
    public setSearchTravelRequestFlexibleDepartureDays(flexDays: number): void {
        if (this.searchTravelRequest)
            this.searchTravelRequest.flexibleDepartureDays = flexDays;
    }

    @Action
    public updateSearchTravelRequestFlexibleDepartureDays(flexDays: number): void {
        this.context.commit('setSearchTravelRequestFlexibleDepartureDays', flexDays);
    }

    @Mutation
    public setSearchTravelRequestAdults(adults: Array<SearchPerson>): void {
        if (this.searchTravelRequest)
            this.searchTravelRequest.rooms[0].adults = adults;
    }

    @Action
    public updateSearchTravelRequestAdults(adults: Array<SearchPerson>): void {
        this.context.commit('setSearchTravelRequestAdults', adults);
    }

    @Mutation
    private setAddSearchTravelRequestAdult(index: number): void {
        const newAdult: SearchPerson = {
            firstName: null,
            middleName: null,
            lastName: null,
            birthdate: null,
            street: null,
            postal: null,
            city: null,
            country: null,
            phone: null,
            email: null,
            age: null,
            gender: null
        };
        if (this.searchTravelRequest)
            this.searchTravelRequest.rooms[index].adults.push(newAdult);
    }

    @Action
    public addSearchTravelRequestAdult(index: number): void {
        this.context.commit('setAddSearchTravelRequestAdult', index);
    }

    @Mutation
    private setRemoveSearchTravelRequestAdult(index: number): void {
        if (this.searchTravelRequest)
            this.searchTravelRequest.rooms[index].adults.pop();
    }

    @Action
    public removeSearchTravelRequestAdult(index: number): void {
        this.context.commit('setRemoveSearchTravelRequestAdult', index);
    }

    @Mutation
    private setAddSearchTravelRequestChild(index: number): void {
        const newChild: SearchPerson = {
            firstName: null,
            middleName: null,
            lastName: null,
            birthdate: null,
            street: null,
            postal: null,
            city: null,
            country: null,
            phone: null,
            email: null,
            age: null,
            gender: null
        };
        if (this.searchTravelRequest)
            this.searchTravelRequest.rooms[index].children.push(newChild);
    }

    @Action
    public addSearchTravelRequestChild(index: number): void {
        this.context.commit('setAddSearchTravelRequestChild', index);
    }

    @Mutation
    private setRemoveSearchTravelRequestChild(index: number): void {
        if (this.searchTravelRequest)
            this.searchTravelRequest.rooms[index].children.pop();
    }

    @Action
    public removeSearchTravelRequestChild(index: number): void {
        this.context.commit('setRemoveSearchTravelRequestChild', index);
    }

    @Mutation
    private setSearchTravelRequestChildAge(params: SearchRoomChildParams): void {
        if (this.searchTravelRequest) {
            this.searchTravelRequest.rooms[params.roomIndex].children[params.childIndex].age = params.age;
        }
    }

    @Action
    public updateSearchTravelRequestChildAge(params: SearchRoomChildParams): void {
        this.context.commit('setSearchTravelRequestChildAge', params);
    }

    @Mutation
    private setAddSearchTravelRequestRoom(): void {
        if (this.searchTravelRequest) {
            const newAdult: SearchPerson = {
                firstName: null,
                middleName: null,
                lastName: null,
                birthdate: null,
                street: null,
                postal: null,
                city: null,
                country: null,
                phone: null,
                email: null,
                age: null,
                gender: null
            };
            const newRoom: SearchRoom = {roomId: undefined, adults: [newAdult], children: []};
            this.searchTravelRequest.rooms.push(newRoom);
        }
    }

    @Action
    public addSearchTravelRequestRoom(): void {
        this.context.commit('setAddSearchTravelRequestRoom');
    }

    @Mutation
    private setDeleteSearchTravelRequestRoom(index: number): void {
        if (this.searchTravelRequest)
            this.searchTravelRequest.rooms.splice(index, 1);
    }

    @Action deleteSearchTravelRequestRoom(index: number): void {
        this.context.commit('setDeleteSearchTravelRequestRoom', index);
    }

    @Mutation
    public setSearchTravelRequestAirports(airport: SearchAirport): void {
        if (this.searchTravelRequest) {
            for (const item of this.searchTravelRequest.airports) {
                if (item.id === airport.id) {
                    item.isSelected = true;
                } else {
                    item.isSelected = false;
                }
            }
        }
    }

    @Action
    public updateSearchTravelRequestAirports(airport: SearchAirport): void {
        this.context.commit('setSearchTravelRequestAirports', airport);
    }
}

export default TravelSearchModule;